import React, { useState } from "react";
import { Phone, ChevronDown, Globe, MapPin, MessageCircle } from "lucide-react";

export const ContactDrop = () => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="contact-drop">
      <button type="button" data-testid="contact-drop-toggle" onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-xs font-medium text-emerald-700 hover:text-emerald-800">
        <Phone className="h-3.5 w-3.5" /> KINOS: +670 77138966
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid="contact-drop-panel" className="mt-1.5 text-xs text-slate-600 space-y-1.5 border border-emerald-100 bg-emerald-50 rounded-lg p-3">
          <a href="tel:+67077138966" data-testid="contact-phone-1" className="flex items-center gap-1.5 hover:text-emerald-700">
            <Phone className="h-3 w-3" /> +670 77138966
          </a>
          <a href="tel:+6703311480" data-testid="contact-phone-2" className="flex items-center gap-1.5 hover:text-emerald-700">
            <Phone className="h-3 w-3" /> +670 3311480
          </a>
          <a href="https://wa.me/67077138966" target="_blank" rel="noreferrer" data-testid="contact-whatsapp"
            className="flex items-center gap-1.5 text-green-700 hover:text-green-800 font-medium">
            <MessageCircle className="h-3 w-3" /> WhatsApp +670 77138966
          </a>
          <a href="https://www.kinos.tl" target="_blank" rel="noreferrer" data-testid="contact-website"
            className="flex items-center gap-1.5 hover:text-emerald-700">
            <Globe className="h-3 w-3" /> www.kinos.tl
          </a>
          <div className="flex items-center gap-1.5" data-testid="contact-address">
            <MapPin className="h-3 w-3" /> Rua Fatuhada, Comoro, Dom-Aleixo, Dili, Timor-Leste
          </div>
        </div>
      )}
    </div>
  );
};
